module.exports = "https://web-assets.ifttt.com/packs/media/solutions_by_industry/smart_home-2a967708.svg";